import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { GeoProvider } from './contexts/GeoContext';
import Header from './components/Header';
import Footer from './components/Footer';
import LiveIndicator from './components/LiveIndicator';
import BackgroundEffects from './components/BackgroundEffects';
import SupportWidget from './components/SupportWidget';
import ErrorBoundary from './components/ErrorBoundary';
import MobileNav from './components/MobileNav';
import SocialProof from './components/SocialProof';
import MobileMenu from './components/MobileMenu';
import Home from './pages/Home';
import Products from './pages/Products';
import Feedbacks from './pages/Feedbacks';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CheckoutPix from './pages/CheckoutPix';
import CheckoutDirect from './pages/CheckoutDirect';
import CheckoutBinance from './pages/CheckoutBinance';
import Orders from './pages/Orders';
import AuthCallback from './pages/AuthCallback';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import ProdAdminPanel from './pages/ProdAdminPanel';
import Support from './pages/Support';
import Status from './pages/Status';
// EN imports
import ENLayout from './components/en/ENLayout';
import HomeEN from './pages/en/HomeEN';
import ProductsEN from './pages/en/ProductsEN';
import FeedbacksEN from './pages/en/FeedbacksEN';
import CartEN from './pages/en/CartEN';
import LoginEN from './pages/en/LoginEN';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <BackgroundEffects />
      <Header />
      <div className="pb-16 md:pb-0">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produtos" element={<Home />} />
            <Route path="/feedbacks" element={<Feedbacks />} />
            <Route path="/carrinho" element={<Cart />} />
            <Route path="/status" element={<Status />} />
            <Route path="/login" element={<Login />} />
            <Route path="/checkout" element={<CheckoutPix />} />
            <Route path="/checkout-auth" element={<Checkout />} />
            <Route path="/checkout-binance" element={<CheckoutBinance />} />
            <Route path="/pedidos" element={<Orders />} />
            <Route path="/suporte" element={<Support />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/prod-admin" element={<ProdAdminPanel />} />
          </Routes>
        </ErrorBoundary>
      </div>
      <Footer />
      <LiveIndicator />
      <SupportWidget />
      <SocialProof />
      <MobileNav onOpenMenu={() => setMenuOpen(true)} />
      <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <GeoProvider>
          <ScrollToTop />
          <Routes>
            {/* EN Routes */}
            <Route element={<ENLayout />}>
              <Route path="/en" element={<HomeEN />} />
              <Route path="/en/products" element={<ProductsEN />} />
              <Route path="/en/feedbacks" element={<FeedbacksEN />} />
              <Route path="/en/cart" element={<CartEN />} />
              <Route path="/en/login" element={<LoginEN />} />
            </Route>

            {/* PT Routes (original) */}
            <Route path="/*" element={<AppContent />} />
          </Routes>
          <Toaster />
          </GeoProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;